import { usePersistState } from './usePersistState';

const STORAGE_KEY = 'usersBeingOnboarded';

export const useTrackOnboardingUsers = () => {
  const [usersBeingOnboarded, setUsersBeingOnboarded] = usePersistState({}, STORAGE_KEY);

  const startTrackingUser = (userIdentifier: string) => {
    setUsersBeingOnboarded((currentUsersBeingOnboarded) => {
      const nextUsersBeingOnboarded = { ...currentUsersBeingOnboarded };
      nextUsersBeingOnboarded[userIdentifier] = true;

      return nextUsersBeingOnboarded;
    });
  };

  const stopTrackingUser = (userIdentifier: string) => {
    setUsersBeingOnboarded((currentUsersBeingOnboarded) => {
      const nextUsersBeingOnboarded = { ...currentUsersBeingOnboarded };
      delete nextUsersBeingOnboarded[userIdentifier];

      return nextUsersBeingOnboarded;
    });
  };

  const userIsBeingOnboarded = (userIdentifier) => {
    return usersBeingOnboarded?.[userIdentifier] === true;
  };

  return {
    startTrackingUser,
    stopTrackingUser,
    userIsBeingOnboarded,
  };
};
